var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCenterPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.508 22.235a1.333 1.333 0 0 1-2.058-1.12V2.018A1.333 1.333 0 0 1 2.508.897l14.758 9.55a1.333 1.333 0 0 1 0 2.239z"
})));
export { SvgCenterPlay as ReactComponent };
export default "/_next/static/images/centerPlay.svg";